import { Component, OnInit, ViewEncapsulation, ViewChild, ViewContainerRef, AfterViewInit, OnDestroy, NgZone } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { DQOIItem } from '@app/cp/shared/models/DQOIItem';
import { DQOIReferenceDataQuery } from './state/dqoi-reference-data.query';
import { DQOIMessage } from '@app/cp/shared/models/DQOIMessage';
import { Subscription } from 'rxjs';
import { DQOISearchEvent } from '@app/cp/shared/models/DQOISearchEvent';
import * as _ from 'lodash';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { DQOISearchComponent } from './search/dqoi-search.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AppClaims } from '../shared/models/AppClaims';

import { SplitButtonComponent } from '@progress/kendo-angular-buttons';
import { ConfirmDialogComponent } from '../shared/components/confirm-dialog/confirm-dialog.component';
import { CRUDActions } from '../shared/enums/CRUDActions';
import { ConfirmOutput } from '../shared/models/ConfirmOutput';
import { CPDialogResult } from '../shared/enums/CPDialogResult';
import { CmProAuthService } from '@app/core/services';
import { UsersBus } from '../shared/models/UsersBus.model';
import { IFeatureFlagSet } from '../shared/decorators/featureflags/featureflagset-decorator';
import { FeatureFlagService } from '../shared/services/feature-flag.service';

@Component({
    selector: 'dqoi-main',
    templateUrl: './dqoi-main.component.html',
    styleUrls: ['./dqoi-main.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DQOIMainComponent implements AfterViewInit, OnInit, OnDestroy {
    saveLastSearchToQueryParams: any;
    searchTarget: SearchTarget = SearchTarget.dispatch;
    private subs_featureFlagSet: Subscription; //place as class variable
    compFeatureFlagSet: IFeatureFlagSet = this as any;




    
    constructor(svc_dqoi: DQOIService, private qry_rd: DQOIReferenceDataQuery,private featureFlagService: FeatureFlagService,
        private router: Router, private authService: CmProAuthService, private globals: GlobalsService,
        private route: ActivatedRoute) {
        this.svc_dqoi = svc_dqoi;

        this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();

        this.url = this.router.url;
        this.subs_featureFlagSet = this.featureFlagService.featureFlagSets.subscribe(data => {
            this.compFeatureFlagSet = data;
        });
    }

    rights: AppClaims = new AppClaims();
    ngOnInit(): void {
        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.rights = user.appClaims;
            }
        });

        this.saveLastSearchToQueryParams = this.route.snapshot.data['saveLastSearchToQueryParams'];
        if (this.saveLastSearchToQueryParams) {
            this.subs_queryParams = this.route.queryParams.subscribe(params => {
                const search = new DQOISearchEvent();
                search.loadFromQueryString(params);
                if (search.hasCriteriaSet() && this.dqoiItems.length === 0) {
                    setTimeout(() => {
                        this.searchTarget = search.searchTarget;
                        this.searchSel(search);
                    }, 10);
                }
            });
        }
    }
    @ViewChild('cnfDialog') protected cnfDialog: ConfirmDialogComponent;
    cnfShow(message: string, action: CRUDActions = CRUDActions.None, data: any = null, title: string = null, code: string = null, okButtonOnly = false) {
        if (CommonFunctions.hasValue(this.cnfDialog)) {
            this.cnfDialog.show(message, action, data, title, code, okButtonOnly);
        }
    }
    confirmDialog(data: ConfirmOutput) {
        let handled: boolean = false;
        if (data.dialogResult === CPDialogResult.ok) {
            if (data.code === "REF_REFDATA") {
                this.refreshReferenceData();
            }
        }
        if (!handled) {
            this.confirmCustom(data);
        }

    }
    confirmCustom(data: ConfirmOutput) {

    }
    private subs_keyPress: Subscription;
    private subs_queryParams: Subscription;

    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    get hasReferenceData(): boolean {
        let retVal: boolean = false;
        try {
            retVal = this.referenceData !== undefined && this.referenceData !== null && CommonFunctions.hasArrayElementValue(this.referenceData.dispatchStatus) ? true : false;
        }
        catch {
            retVal = false;
        }
        return retVal;

    }
    get serviceMode(): any {
        return !this.hasReferenceData || this.rights.FG2RegularAccess === true ? "0" : this.referenceData.serviceMode;
    }
    @ViewChild("newButton") newButton: SplitButtonComponent;

    setSearchEventFromRoute(url: string) {
        if (url.toLowerCase().indexOf("dispatch") >= 0) {
            this.searchComp.searchTargetChanged(SearchTarget.dispatch);
        }
        else if (url.toLowerCase().indexOf("quote") >= 0) {
            this.searchComp.searchTargetChanged(SearchTarget.quote);
        }
        else if (url.toLowerCase().indexOf("order") >= 0) {
            this.searchComp.searchTargetChanged(SearchTarget.order);
        }
        else if (url.toLowerCase().indexOf("invoice") >= 0) {
            this.searchComp.searchTargetChanged(SearchTarget.invoice);
        }
    }
    @ViewChild('searchComp') protected searchComp: DQOISearchComponent;
    @ViewChild("searchContainer", { read: ViewContainerRef }) public searchContainerRef: ViewContainerRef;

    url: string;
    svc_dqoi: DQOIService;
    subs_dataSearchEvent: Subscription;
    dqoiItems: DQOIItem[] = [];
    trackByFunction(index: number, item: DQOIItem) {

        if (!item) return null;
        return item.index;
    }
    onDQOIMessage(e: DQOIMessage) {
        if (e.messageType === MessageType.close && CommonFunctions.hasValue(e.messageData)) {
            let index: number = e.messageData;
            let arr: DQOIItem[] = [];
            for (let i = 0; i < this.dqoiItems.length; i++) {
                if (index !== this.dqoiItems[i].index) {
                    arr.push(this.dqoiItems[i]);
                }
            }
            this.dqoiItems = arr;
            this.clearQueryParamsIfNotInDQOIItems();
        }
        else if (e.messageType === MessageType.searchChanged) {
            this.searchComp.searchTargetChanged(e.messageData);
        }
    }
    private clearQueryParamsIfNotInDQOIItems() {
        //check if querystring contains any matching values to the dqoiItems
        let queryParams: any = this.route.snapshot.queryParams;
        let hasDQOIItem: boolean = false;
        if (queryParams && this.dqoiItems.length > 0) {
            const search = new DQOISearchEvent();
            search.loadFromQueryString(queryParams);
            this.dqoiItems.forEach(item => {
                if (
                    (search.id && search.id === item.id) ||
                    (search.quoteNumber && search.quoteNumber === item.number) ||
                    (search.invoiceNumber && search.invoiceNumber === item.number)  ||
                    (search.orderNumber && search.orderNumber === item.number)  ||
                    (search.dispatchId && search.dispatchId === item.dispatchId)
                ) {
                    hasDQOIItem = true;
                    return;
                }
            });
        }

        if (this.dqoiItems.length === 0 || !hasDQOIItem) {
            setTimeout(() => {
                this.router.navigate([], {
                    queryParams: {}
                });
            }, 0);

        }
    }
    addDQOIItem(data: DQOIItem) {
        let index: number = 1;
        if (CommonFunctions.hasArrayValue(this.dqoiItems)) {
            index = Math.max(...this.dqoiItems.map(x => x.index), 0) + 1;
        }
        data.index = index;

        this.svc_dqoi.setDQOIItem(data);
        this.dqoiItems = _.concat(data, this.dqoiItems);
    }
    getNewButtonData() {
        if (this.rights.MaintainDispatches) {
            if (this.compFeatureFlagSet['ui-hide-zuggit-menu-items-extended']) {
                this.newButtonData.push({ text: 'New Sales Order', click: () => { this.newDQOI('D'); } });
            } else { this.newButtonData.push({ text: 'New Dispatch', click: () => { this.newDQOI('D'); } });}

            
        }
        if (this.rights.MaintainQuotes) {
            this.newButtonData.push({ text: 'New Quote', click: () => { this.newDQOI('Q'); } });
        }
        if (this.rights.MaintianOrders) {
            this.newButtonData.push({ text: 'New Order', click: () => { this.newDQOI('O'); } });
        }
        if (this.rights.CreateInvoices) {
            this.newButtonData.push({ text: 'New Invoice', click: () => { this.newDQOI('I'); } });
        }
    }

    ngAfterViewInit() {
        this.getNewButtonData();
        this.setSearchEventFromRoute(this.url);
        this.svc_dqoi.dropQuickSearchAnchor(this.searchContainerRef);
    }

    ngOnDestroy() {
        this.svc_dqoi.dropQuickSearchAnchor(null);
        CommonFunctions.unsubscribe(this.subs_keyPress);
        CommonFunctions.unsubscribe(this.subs_queryParams);
        this.authService.unsubscribeToLoginEvents();
    }
    test() {
        //let newItem: DQOIItem = { searchTarget: SearchTarget.dispatch,  target: 'D', id: 'DFF7B65B-F5D2-46CD-91F8-FD3862BB1FDA', index: 3, isSearchable: false, dispatchId: null, quoteId: null, orderId: null, invoiceId: null, number: null };
        //this.dqoiItems.push(newItem);
    }
    tryRefreshReferenceData() {
        let msg: string = "Are you sure you would like to Refresh this data?";
        let title: string = "Refresh Reference Data From the Server";
        this.cnfShow(msg, CRUDActions.None, null, title, "REF_REFDATA", false);
    }

    refreshReferenceData() {
        this.qry_rd.forceRefresh(this.globals.companyId);
    }
    mergeDispatches() {

    }
    loadJob(id: any) {
        if (id) {
            let url: string = "/quickview/construction/10/" + id;
            this.navigate(url);
        }

    }

    navigate(url: string) {
        setTimeout(() => {
            window.open(url, "_blank");
        });
    }

    searchSel(data: DQOISearchEvent) {
        let se: DQOISearchEvent = new DQOISearchEvent(data);
        let item: DQOIItem = null;
        let idTarget = se.searchTarget + ":" + se.id;

        if (se.hasDispatchId) {
            if (se.isConstruction) {
                this.loadJob(se.dispatchId);
            }
            else {
                this.svc_dqoi.getDQOITemFromDb(idTarget).subscribe((newData: DQOIItem) => {
                    item = new DQOIItem(newData);

                    //item.id = data.id;
                    //item.number = data.num
                    item.searchTarget = se.searchTarget;
                    switch (item.searchTarget) {
                        case SearchTarget.dispatch:
                            item.id = se.dispatchId;
                            item.dispatchId = item.id;
                            break;
                        case SearchTarget.invoice:
                            item.number = se.invoiceNumber;
                            item.id = se.id;
                            break;
                        case SearchTarget.quote:
                            item.number = se.quoteNumber;
                            item.id = se.id;
                            break;
                        case SearchTarget.order:
                            item.number = se.orderNumber;
                            item.id = se.id;
                            break;
                    }
                    if (CommonFunctions.hasValue(item.id) || CommonFunctions.hasValue(item.number)) {
                        this.addDQOIItem(item);
                        this.saveSearchToQueryParams(se);
                    }
                });
            }
        }
        else {
            item = new DQOIItem();
            item.searchTarget = se.searchTarget;
            if (item === null && se !== null) {
                switch (se.searchTarget) {
                    case SearchTarget.dispatch:
                        item.id = se.dispatchId;
                        item.dispatchId = item.id;
                        break;
                    case SearchTarget.invoice:
                        item.number = se.invoiceNumber;
                        break;
                    case SearchTarget.quote:
                        item.number = se.quoteNumber;
                        break;
                    case SearchTarget.order:
                        item.number = se.orderNumber;
                        break;
                }
            }
            if (CommonFunctions.hasValue(item.id) || CommonFunctions.hasValue(item.number)) {
                this.addDQOIItem(item);
                this.saveSearchToQueryParams(se);
            }
        }
    }
    private saveSearchToQueryParams(se: DQOISearchEvent) {
        if (this.saveLastSearchToQueryParams) {
            //update url with querystring
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: se.getQueryStringParams(),
                queryParamsHandling: 'merge'
            });
        }
    }

    @ViewChild('container', { read: ViewContainerRef }) public containerRef: ViewContainerRef;
    public newButtonData: Array<any> = [
    ];

    newDQOI(code: string) {
        this.newButton.toggle(false);
        let item: DQOIItem = new DQOIItem();
        item.isNew = true;
        switch (code) {
            case 'D':
                item.searchTarget = SearchTarget.dispatch;
                break;
            case 'Q':
                item.searchTarget = SearchTarget.quote;
                break;
            case 'O':
                item.searchTarget = SearchTarget.order;
                break;
            case 'I':
                item.searchTarget = SearchTarget.invoice;
                break;
        }
        this.addDQOIItem(item);
    }
}
